import { margin, padding } from "ds_legacy/materials/metrics";
import {
  Section,
  SectionRow,
  TextAreaWithLabel,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionFour = () => {
  const translations = useTranslations();

  return (
    <Section title={translations.patientForms.drvMedicalForm.sectionFour.title}>
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextAreaWithLabel
          elementName="clinical_findings"
          isBold
          label={translations.patientForms.drvMedicalForm.descriptionHistory}
          sx={{ margin: margin(0) }}
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          elementName="patient_weight"
          endAdornment={translations.abbreviations.kilogram.abbreviation}
          isBold
          label={translations.patientForms.drvMedicalForm.sectionFour.weight}
          textInputType="number"
        />
        <TextInputWithLabel
          elementName="patient_height"
          endAdornment={translations.abbreviations.centimeter.abbreviation}
          isBold
          label={translations.patientForms.drvMedicalForm.sectionFour.height}
          textInputType="number"
        />
      </SectionRow>
    </Section>
  );
};
